import React from 'react';
import './ConfirmModal.css';

// Single reusable modal for both confirm-type (Cancel/Confirm) and
// error-type (single OK) dialogs, replacing window.confirm()/alert()
// across AdminPanel.jsx (1F enhancement).
const ConfirmModal = ({ isOpen, type = 'confirm', message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', onConfirm, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="confirm-modal-overlay" onClick={onClose}>
            <div className="confirm-modal-card" onClick={(e) => e.stopPropagation()}>
                <p className="confirm-modal-message">{message}</p>
                <div className="confirm-modal-actions">
                    {type === 'confirm' ? (
                        <>
                            <button className="confirm-modal-btn-cancel" onClick={onClose}>
                                {cancelLabel}
                            </button>
                            <button className="confirm-modal-btn-confirm" onClick={onConfirm}>
                                {confirmLabel}
                            </button>
                        </>
                    ) : (
                        <button className="confirm-modal-btn-confirm" onClick={onClose}>
                            OK
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;